/* Tour Context — Feb 2026
 *
 * Provides `startTour(key)`, `cancelTour()`, `finishTour()` to children.
 * The TourController consumes `runKey` to decide which tour (if any) to
 * show via react-joyride.
 */
import { createContext, useContext, useState, useMemo, useCallback } from 'react';

const TourContext = createContext(null);

export function TourProvider({ children }) {
  const [runKey, setRunKey] = useState(null);

  const startTour = useCallback((key) => setRunKey(key), []);
  const cancelTour = useCallback(() => setRunKey(null), []);
  const finishTour = useCallback(() => setRunKey(null), []);

  const value = useMemo(
    () => ({ runKey, startTour, cancelTour, finishTour }),
    [runKey, startTour, cancelTour, finishTour]
  );

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}

export function useTour() {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used within a TourProvider');
  return ctx;
}
